import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { getInt } from 'utils/functions';
import PropTypes from 'prop-types';
import FinancialProductWarrantiesTable from './FinancialProductWarrantiesTable';
import { useMutation, useSubscription } from 'hooks/apollo';
import { REMOVE_FINANCIAL_PRODUCT_WARRANTY } from '../../../mutations';
import { FINANCIAL_PRODUCT_WARRANTY_REMOVED } from '../../../subscriptions';
import { useToast } from 'hooks/toasts/useToast';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const FinancialProductWarrantiesContainer = ({ canWrite, warranties, isSaved }) => {
  const addToast = useToast();
  const [t] = useTranslation();
  const match = useRouteMatch();
  const productId = match.params.id && getInt(match.params.id);
  const historyContext = useHistoryWithContext();

  const [deleteFinancialProductWarranty] = useMutation(REMOVE_FINANCIAL_PRODUCT_WARRANTY);

  useSubscription(FINANCIAL_PRODUCT_WARRANTY_REMOVED, {
    onData: ({ data: _, client }) => {
      addToast(t('FinancialProduct.Details.Warranties.FinancialProductWarrantyRemoved'), 'success');
      client.cache.evict({
        id: `FinancialProductItem:{"productId":${productId}}`
      });
      client.cache.gc();
    }
  });

  const handleAdd = () => {
    historyContext.push(`/financialProducts/${productId}/warranties/new`);
  };

  const handleEdit = leasingFinancialProductXWarrantyId => () => {
    historyContext.push(`/financialProducts/${productId}/warranties/${leasingFinancialProductXWarrantyId}`);
  };

  const handleDelete = leasingFinancialProductXWarrantyId => () => {
    if (window.confirm(t('FinancialProduct.Details.Warranties.DeleteFinancialProductWarranty'))) {
      deleteFinancialProductWarranty({
        variables: {
          input: { leasingFinancialProductXWarrantyId }
        }
      });
    }
  };

  return (
    <FinancialProductWarrantiesTable
      canWrite={canWrite}
      warranties={warranties}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      isSaved={isSaved}
    />
  );
};

FinancialProductWarrantiesContainer.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  warranties: PropTypes.array.isRequired,
  isSaved: PropTypes.bool.isRequired
};

export default FinancialProductWarrantiesContainer;
